import React, { FC } from "react"
import { Navigate } from "react-router-dom"

import { useAppSelector } from "redux/hooks"
import { selectAccessToken } from "redux/features/auth/authSlice"
import TokenService from "redux/api/tokenService"

interface ProtectedRouteProps {
  component: React.ComponentType
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ component: Component }) => {
  const accessToken = useAppSelector((state) => selectAccessToken(state))

  if (accessToken) {
    const isValid = TokenService.validate(accessToken)

    if (isValid) {
      return <Component />
    } else {
      return <Navigate to="/login" replace />
    }
  }

  return <Navigate to="/login" replace />
}

export default ProtectedRoute
